"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var PhoneNumberInfo = function (_a) {
    var phoneNumber = _a.phoneNumber;
    var noShowLabels = ["other", null];
    var phoneNumberLabel = noShowLabels.includes(phoneNumber.label) ? "" : "(" + phoneNumber.label + ")";
    return (React.createElement("div", { className: "u-spaceBottomSm" },
        React.createElement(teamsnap_ui_1.Icon, { name: "megaphone", mods: "u-spaceRightSm u-colorGrey" }),
        React.createElement("span", { className: "u-padTopSm" }, phoneNumber.number),
        (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.label)
            && React.createElement("span", { className: "u-spaceLeftXs" }, phoneNumberLabel)));
};
exports.default = PhoneNumberInfo;
//# sourceMappingURL=phone-number-info.js.map